import { useAppCommandPalette } from '@watershed/shared-frontend/components/CommandPalette/appCommandPalette';

import SettingsCommandPalettePage from './SettingsCommandPalettePage';

/**
 * Hook to integrate settings command palette into the settings layout.
 * Sets up the command palette with the settings-specific search component.
 *
 * @returns void
 */
export function useSettingsCommandPalette() {
  const appCommandPalette = useAppCommandPalette({
    enabled: true,
    initialLocation: {
      component: SettingsCommandPalettePage,
      props: {},
    },
    // Higher priority (2) when in settings context to override the default command palette
    priority: 2,
  });

  // Return the command palette context for potential use in the component
  return appCommandPalette;
}
